import React from "react";
import "./ProgressImport.css";
import { useTranslation } from "react-i18next";

export const BulkImportSteper = (props) => {
  const { step } = props;
  const { t: translator } = useTranslation();

  return (
    <div className="p-2">
      <div className="row pl-2 pt-2">
        {step ? (
          <div className="progress-meter-import">
            <ol className="progress-meter-import">
              <li className={`progress-point ${step >= 1 ? "done" : "todo"}`}>
                {translator("BulkImportSteper-FileUpload")}
              </li>
              <li className={`progress-point ${step >= 2 ? "done" : "todo"}`}>
                {translator("BulkImportSteper-DataVerification")}
              </li>
              <li className={`progress-point ${step >= 3 ? "done" : "todo"}`}>
                {translator("BulkImportSteper-Save")}
              </li>
            </ol>
          </div>
        ) : (
          ""
        )}
      </div>
      <div className="card container-fluid p-0">
        <div className="card-header card-wrap">
          <span>{props.subtitle}</span>
        </div>
        <div className="card-body">{props.children}</div>
      </div>
    </div>
  );
};
